import React from 'react';
import { colors, spacing, radius, fontStack } from '../design-system/tokens';

/**
 * EmptyState — small placeholder for "no data yet" surfaces.
 *
 * Props:
 *   - icon    : ReactNode?  (small visual, e.g. an inline svg)
 *   - title   : string?
 *   - message : string
 *   - cta     : { label, onClick } | undefined
 */
export default function EmptyState({ icon, title, message, cta }) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: `${spacing.lg}px ${spacing.base}px`,
        gap: 8,
        color: colors.textSecondary,
        fontFamily: fontStack,
      }}
    >
      {icon && (
        <div style={{ marginBottom: 4, color: colors.textSecondary }}>
          {icon}
        </div>
      )}
      {title && (
        <div
          style={{
            fontSize: 14,
            fontWeight: 600,
            color: colors.textPrimary,
          }}
        >
          {title}
        </div>
      )}
      <div style={{ fontSize: 13, lineHeight: 1.5, maxWidth: 360 }}>
        {message}
      </div>
      {cta && (
        <button
          type="button"
          onClick={cta.onClick}
          style={{
            marginTop: 10,
            padding: '8px 16px',
            borderRadius: radius.sm,
            border: `1px solid ${colors.border}`,
            backgroundColor: colors.card,
            color: colors.textPrimary,
            fontSize: 13,
            fontWeight: 500,
            fontFamily: fontStack,
            cursor: 'pointer',
          }}
        >
          {cta.label}
        </button>
      )}
    </div>
  );
}
